import ISiteDiaryAuthorisedTemporaryWorkers from "interfaces/SiteDiary/AuthorisedTemporaryWorkers/ISiteDiaryAuthorisedTemporaryWorkers";
import { Check } from "react-bootstrap-icons";

const InductedTemplate = (props: ISiteDiaryAuthorisedTemporaryWorkers): any => {
  const { inducted } = props;
  return (
    <>
      {inducted && <Check data-testid="authorisedVisitorInducted" />}
    </>
  );
};
export default InductedTemplate;
